import React, { useContext, useState } from "react";
import "./NavBar.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import PNZLogin from "./PNZLogin";
import eventBus from "../EventBus";
import { AppContext } from "../App";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#000000",
    },
    bg: {
      main: "#212121",
    },
  },
});

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const { setAccessToken } = useContext(AppContext);

  function handleClick() {
    eventBus.dispatch("ButtonClicked", { message: true });
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <AppBar position="static" sx={{ backgroundColor: "#212121" }}>
          <Container maxWidth="100%">
            <Toolbar
              disableGutters
              sx={{
                display: { xs: "flex" },
                flexDirection: "row",
                backgroundColor: "#212121",
                justifyContent: "space-between",
              }}
            >
              <Box
                className="header-logo"
                sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
              >
                <span className="logo-image">
                  <img src="./static/images/pnz-logo.png" alt="logo" />
                </span>
                <Typography
                  variant="h5"
                  color="primary"
                  sx={{
                    display: { xs: "none", md: "flex" },
                    fontFamily: "sans-serif",
                    fontWeight: 500,
                    letterSpacing: ".1rem",
                    textDecoration: "none",
                  }}
                  noWrap
                >
                  | Account Information API
                </Typography>
              </Box>
              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon color="primary" />
                </IconButton>

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                >
                  <MenuItem className="menuitem">
                    <PNZLogin setAccessToken={setAccessToken} />
                  </MenuItem>
                </Menu>
              </Box>

              {/*samll screen */}
              <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                <span className="logo-image">
                  <img src="./static/images/pnz-logo.png" alt="logo" />
                </span>
              </Box>
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                }}
              >
                <PNZLogin setAccessToken={setAccessToken} />
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
      </ThemeProvider>
    </>
  );
}
export default ResponsiveAppBar;
